import Main from "@/layout/main.vue";
import Blank from "@/layout/blank.vue";
const routes = [
    {
        path: "/order",
        name: "order",
        meta: { title: "คำสั่งซื้อสินค้า" },
        redirect: "/order/renew/lists",
        component: Main,
        children: [
            {
                path: "/order/renew/lists",
                name: "renew_order",
                meta: {
                    title: "คำสั่งต่ออายุ",
                    icon: "icon_fenxiao_order",
                    parentPath: "/order",
                    permission: ["view"],
                },
                component: () => import("@/views/order/renew/lists.vue"),
            },
            {
                path: "/order/renew/detail",
                name: "renew_order_detail",
                meta: {
                    hidden: true,
                    title: "คำสั่งต่ออายุ",
                    parentPath: "/order",
                    prevPath: "/order/renew/lists"
                },
                component: () => import("@/views/order/renew/detail.vue"),
            },
        ],
    },
];
export default routes;
